// extracted by mini-css-extract-plugin
export var itemButton = "image-gallery-module--item-button--7Dbhm";
export var ratio = "image-gallery-module--ratio--YtOgK";
export var slider = "image-gallery-module--slider--GEZpN";